import type { ITSPayloadBet, ITSPayloadBoard } from '../../@types/ITSPayload.js';
import BoardFulltraff from '../board/BoardFulltraff.js';
import BetScore from './BetScore.js';

type ITSERFulltraffBet = ITSPayloadBet<{
  erScoreBoardData: {
    boards: ITSPayloadBoard<string>[];
    simpleRowsOnly: boolean;
  };
}>;

/**
 * Bet class for Score products like Bomben, Matchen and Fullträff.
 * Contains product specific logic for eg. reduction systems like RSYS.
 */
class BetFulltraff extends BetScore {
  /**
   * Loops over boards to generate correct data for all boards.
   *
   * @returns Object with correct ITS structure for score external systems
   */
  protected override composeOwnRowsBoards(): ITSERFulltraffBet {
    const boards = this.boards.map((board) => board.composeOwnRows());

    const itsPayload = {
      erScoreBoardData: {
        boards,
        simpleRowsOnly: this.isSingleRowsOnly,
      },
    };

    type ITSBetFulltraff = ITSPayloadBet<typeof itsPayload>;

    return itsPayload as ITSBetFulltraff;
  }

  protected override getBoard(): BoardFulltraff {
    return new BoardFulltraff(this.product);
  }
}

export default BetFulltraff;
